import { Fragment } from 'react';
import { LIFECYCLE } from '../data/constants';

/* The signature lifecycle rail from the sample UI: position, not colour,
   carries status. Reused wherever an enrolment's status needs showing. */
function LifeRail({ status, withLabel }) {
  const fail = status === 'onboarding_unsuccessful';
  const idx = fail ? 1 : LIFECYCLE.indexOf(status);
  return (
    <span className="life" role="img" aria-label={`Status: ${status}`}>
      {LIFECYCLE.map((st, i) => (
        <Fragment key={st}>
          {i > 0 && (
            <span className={'bar' + (i <= idx ? (fail && i === 1 ? ' fail' : ' on') : '')}></span>
          )}
          <span
            className={
              'node' +
              (i <= idx ? ' on' : '') +
              (i === idx ? ' cur' : '') +
              (fail && i === 1 ? ' fail' : '')
            }
          ></span>
        </Fragment>
      ))}
      {withLabel && <span className={`life-lbl ${status}`}>{status.replace(/_/g, ' ')}</span>}
    </span>
  );
}

export default LifeRail;
